import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faClosedCaptioning as faCaptionsInactive } from '@fortawesome/free-regular-svg-icons';
import { faCheck, faClosedCaptioning as faCaptionsActive } from '@fortawesome/free-solid-svg-icons';
import { Subtitle } from '../../../../../@generated';

@Component({
    selector: 'app-video-subtitles-picker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FaIconComponent],
    styles: `
      @use "variables" as *;
      @use "functions" as *;

      fa-icon.disabled {
        color: #6b7280 !important;
      }

      .video-speeds {
        margin-right: 2rem;
        cursor: pointer;
        position: relative;
        display: flex;

        @include break(540px) {
          margin-right: 1rem;
        }
      }

      .overlay {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 0;
        left: 50%;
        transform: translate(-50%, -105%);
        min-width: 100px;
        z-index: 10;
        background-color: $dark;
        opacity: 0.85;

        &.hide {
          opacity: 0;
          pointer-events: none;
        }
      }

      .video-speed {
        display: flex;
        align-items: center;
        padding: 0.25rem 0.5rem;

        .check {
          display: flex;
          justify-content: center;
          width: 35px;

          fa-icon {
            font-size: 12px;
          }
        }

        span {
          font-size: 14px;
        }

        &:hover {
          background-color: #434343;
        }
      }
    `,
    template: `
        <div class="video-speeds" (click)="toggleMenu()">
            <fa-icon
                [class.disabled]="!subtitles?.length"
                [title]="!subtitles?.length ? 'Subtitles not available' : 'Subtitles'"
                [icon]="selectedSubtitle === null ? faCaptionsInactive : faCaptionsActive"
            />
            <div class="overlay" [hidden]="!showMenu()">
                @for (subtitle of subtitles; track subtitle.id) {
                    <div class="video-speed" (click)="select(subtitle)">
                        <div class="check">
                            @if (subtitle.id === selectedSubtitle?.id) {
                                <fa-icon [icon]="faCheck" />
                            }
                        </div>
                        <span>{{ subtitle.language }}</span>
                    </div>
                }
                <div class="video-speed" (click)="select(null)">
                    <div class="check">
                        @if (selectedSubtitle === null) {
                            <fa-icon [icon]="faCheck" />
                        }
                    </div>
                    <span>Off</span>
                </div>
            </div>
        </div>
    `
})
export class VideoPlayerSubtitlesComponent {
    @Input({ required: true }) subtitles?: Subtitle[] | null | undefined;
    @Output() onChange = new EventEmitter<Subtitle | null>();
    selectedSubtitle: Subtitle | null = null;
    showMenu = signal(false);
    faCaptionsActive = faCaptionsActive;
    faCaptionsInactive = faCaptionsInactive;
    faCheck = faCheck;

    select(subtitle: Subtitle | null): void {
        this.selectedSubtitle = subtitle;
        this.onChange.emit(subtitle);
    }

    toggleMenu() {
        if (!this.subtitles?.length) {
            return;
        }

        this.showMenu.set(!this.showMenu());
    }
}
